import React from 'react';
import { Phone, Tag, Clock } from 'lucide-react';
const PHONE = '586-203-3701';
export function CouponBanner() {
  return <div className="w-full bg-gradient-to-r from-[#1a2332] via-[#2d3a4d] to-[#1a2332] text-white" data-id="element-54" data-mp="jlz5ib95zr01">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-55" data-mp="eogso9s10rmr">
        <div className="flex items-center gap-2" data-id="element-56" data-mp="17ccxy2vnvrv5">
          <Tag className="w-5 h-5 text-[#2DB8E0]" data-id="element-57" data-mp="17b1lzfs2bdsy" />
          <span className="text-[#2DB8E0] font-bold uppercase tracking-wider text-xs sm:text-sm" data-id="element-58" data-mp="12d9wesew43rx">
            Limited Time Offer
          </span>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3" data-id="element-59" data-mp="xkypv6pn9jqe">
          <span className="font-bold text-base sm:text-lg" data-id="element-60" data-mp="smox12re6v7y">
            $500 OFF Your Complete Roof Replacement
          </span>
          <span className="hidden sm:inline text-slate-400" data-id="element-61" data-mp="1q4xcsgeizwfy">|</span>
          <span className="inline-flex items-center gap-1.5 text-amber-300 text-sm font-semibold" data-id="element-62" data-mp="1lbcbofhmymcj">
            <Clock className="w-4 h-4" data-id="element-63" data-mp="dy67yp4vwom4" />
            Only 5 free inspections left this week
          </span>
        </div>
        <a href={`tel:${PHONE.replace(/-/g, '')}`} className="hidden sm:inline-flex items-center gap-1.5 ml-2 text-[#2DB8E0] hover:text-white font-semibold underline underline-offset-2" data-id="element-64" data-mp="iv50j38wgni7">
          <Phone className="w-4 h-4" data-id="element-65" data-mp="93s92cr0jzcp" /> {PHONE}
        </a>
      </div>
    </div>;
}